import React, { useState, useEffect } from 'react';
import axios from 'axios';
import useApiUrl from '../framework/hooks/useApiUrlHook';
import Preloader from '../components/Preloader';
import Navigation from '../components/Navigation';
import EorikSlider from '../components/slider/EorikSlider';

export default function HomePage({ page }) {
    const apiUrl = useApiUrl();
    const [data, setData] = useState([]);

    const getData = () => {
        axios
            .get(`${apiUrl}/home/data`)
            .then((response) => {
                setData(response.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    useEffect(() => {
        if (apiUrl != null) getData();
    }, [apiUrl]);

    if (!data) return <Preloader />;

    return (
        <>
            <Navigation home page={page} />
            {/* Start Ecorik Slider Area */}
            <section className="eorik-slider-area">
                <EorikSlider items={data?.slideshow} random imageTyoe="groot" quality={50} showText />

                <div className="page-link-card-wrapper">
                    <div className="container">
                        <ul className="page-link-card">
                            {data?.hotspots?.map((location) => (
                                <li key={location.id}>
                                    <a href={`/hotspots/${location.url}`}>
                                        <h3>Ontdek {location.titel}</h3>
                                        <p>{location.hotspots} hotspots</p>
                                        <div className="left-rightbtn-area">
                                            <div className="right-container">
                                                <button className="right-container-button w-323 green">
                                                    <span className="short-text">
                                                        <i className="ri-arrow-right-s-line" id="icon-chat" />
                                                    </span>
                                                    <span className="long-text">Volgende Hotspot</span>
                                                </button>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
                <div className="app-dowanload">
                    <div className="left-rightbtn-area">
                        <div className="all-dowanload-now">
                            <img src="/assets/images/icon/dowanload.svg" alt="" />
                        </div>
                        <div className="right-container">
                            <div className="mb-3">
                                <a
                                    href="/app/google-play"
                                    target="_blank"
                                    className="right-container-button w-323 green"
                                >
                                    <span className="short-text">
                                        <i
                                            className="ri-google-play-fill"
                                            id="icon-chat"
                                            style={{ fontWeight: 'normal' }}
                                        />
                                    </span>
                                    <span className="long-text">Download Play Store</span>
                                </a>
                            </div>
                            <div className="">
                                <a
                                    href="/app/apple-store"
                                    target="_blank"
                                    className="right-container-button w-323 green"
                                >
                                    <span className="short-text">
                                        <i className="ri-apple-fill" id="icon-chat" style={{ fontWeight: 'normal' }} />
                                    </span>
                                    <span className="long-text">Download Play Apple</span>
                                </a>
                            </div>
                        </div>
                    </div>
                    <img src="/assets/images/banner/mobile-img.png" className="mobile-img" alt="mobile-img" />
                </div>
            </section>
            {/* End Ecorik Slider Area */}
            <div className="right-option-wrap">
                <div className="d-flex align-items-center">
                    <img src="/assets/images/right-option.png" className="right-option" alt="right-option" />
                    <a href="/">
                        <img src="/assets/images/right-text.png" className="right-text" alt="right-text" />
                    </a>
                </div>
            </div>
            {/* Start Go Top Area */}
            <div className="go-top">
                <i className="ri-arrow-up-s-fill" />
                <i className="ri-arrow-up-s-fill" />
            </div>
            {/* End Go Top Area */}
        </>
    );
}
